export const onSocialSubmit = (url: string, handleSocialLoginMessageEvent: () => void) => {
  window.addEventListener(
    'message',
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    handleSocialLoginMessageEvent,
  );
  const link = `${url}&generateToken=true&isAjax=true`;
  window.open(link);
};
